module.exports = __webpack_public_path__ + "static/media/sports.7df0d019.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/sports.svg
// module id = 651
// module chunks = 36